import { Switch } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

const DarkModeSwitch = ({
	isDarkMode,
	toggleDarkMode,
}: { isDarkMode: boolean; toggleDarkMode: () => void }) => {
	const theme = useAppTheme();
	return (
		<Switch
			value={isDarkMode}
			onValueChange={toggleDarkMode}
			color={theme.colors.secondary}
			aria-checked={isDarkMode}
			aria-label="Dark mode switch"
		/>
	);
};

export default DarkModeSwitch;
